

export const password = {
  label: "Password",
  type: "string",
};

export const email = {
  label: "Email",
  type: "string",
};